import {
  APPLY_CONDITION_TO_CANVAS,
  START,
  SUCCESS,
  FAIL
} from "../constants/action-types";
import Mediator from "../services/Mediator";

export const applyConditionToCanvas = (prevCondition) => {
  return (dispatch, getState) => {
    dispatch({
      type: APPLY_CONDITION_TO_CANVAS + START
    });
    (async () => {
      try {
        const {condition} = getState();
        await Mediator.applyConditionToCanvas(condition, prevCondition);
        dispatch({
          type: APPLY_CONDITION_TO_CANVAS + SUCCESS
        });
      } catch (e) {
        dispatch({
          type: APPLY_CONDITION_TO_CANVAS + FAIL,
          error: `Произошла ошибка при загрузке товара`
        });
        throw e;
      }
    })();
  };
};
